import { Interpolation } from '@emotion/react';

type ThemeStyles = {
  [k in string]: Interpolation<any>;
};

export const styles: ThemeStyles = {
  Dismissal: {
    position: 'relative',
    padding: 5,
    borderBottom: '1px solid #d1d1d1'
  },
  CloseDismissal: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    border: 'none',
    background: 'transparent',
    color: 'grays.500',
    fontWeight: 'bold',
    fontSize: 5
  }
};
